"use client";
import React from "react";
import { Button } from "@/components/ui/button";

type AuctionButtonProps = {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void | Promise<void>;
};

export function AuctionButton({
  children,
  className,
  onClick,
}: AuctionButtonProps) {
  return (
    <Button
      className={`w-full rounded-full bg-blue-800 px-3 py-2 text-sm font-normal text-white transition-colors hover:bg-black focus-visible:ring-0 focus-visible:ring-offset-0 ${className ?? ""}`.trim()}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}
